import { SelectAsyncInput } from '@core/components/Select';
import transportadoraApi from 'app/services/api/transportadoraApi';
import React from 'react';

const SelectTransportadora = ({
  id,
  name,
  label,
  value,
  touched,
  error,
  onBlur,
  onChange,
  required,
  autoFocus,
  disabled,
}) => {
  return (
    <SelectAsyncInput
      id={id}
      name={name}
      label={label}
      value={value}
      autoFocus={autoFocus}
      required={required}
      onChange={(event, value) => {
        onChange({
          target: {
            id,
            value,
          },
        });
      }}
      touched={touched}
      error={error}
      onBlur={onBlur}
      getOptionKey={(option) => {
        return option?.id;
      }}
      getOptionLabel={(option) => {
        return option?.pessoa?.nome;
      }}
      fetchData={async (query = '', next = 0) => {
        if (typeof query === 'object') {
          query = '';
        }
        const response = await transportadoraApi.buscarTransportadoras({
          size: 500,
          sort: 'pessoa.nome',
          page: next,
          q: query,
        });

        //const links = parseHeaderForLinks(response.headers.link);
        const totalItems = response.headers['x-total-count'];
        const data = response?.data?.content || [];

        return { data, totalItems };
      }}
      fetchOnFocus
      disabled={disabled}
    />
  );
};

export default SelectTransportadora;
